import { Component, type ReactNode } from "react";
import { reportError } from "../lib/sentry";

interface Props {
  children: ReactNode;
  /** Optional label so reports say which screen crashed. */
  area?: string;
}
interface State {
  error: Error | null;
}

/** Catches render crashes, reports them, and shows a recoverable screen. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string | null }) {
    reportError(error, { area: this.props.area ?? "app", componentStack: info.componentStack });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="screen center" style={{ paddingTop: 80 }}>
        <div className="brand" style={{ fontSize: 28 }}>Fuse</div>
        <p className="muted" style={{ marginTop: 12 }}>
          Something went wrong on this screen. It's been reported.
        </p>
        <button className="btn" onClick={() => this.setState({ error: null })}>
          Try again
        </button>
        <button className="btn btn-ghost" onClick={() => window.location.assign("/")}>
          Back to home
        </button>
      </div>
    );
  }
}
